import { HeaderCell, Row } from './StyledTableComponents';
import React from 'react';
import { useDate } from '../../../utility/useDate';

import styles from "./KmosView.module.css";

const KmosDateHeaderRow: React.FunctionComponent<{
    dates: Date[],
    subHeader: string
}> = (props) => {
    const { dates, subHeader } = props;
    const { toFormattedDateString } = useDate()

    return (<Row>
        <HeaderCell></HeaderCell>
        {dates.map((date: Date, index: number) => <HeaderCell key={`${date}-${index}`}>
            <div className={styles.headerContainer}>
                <div className={styles.dateHeader}>
                    {toFormattedDateString(date)}
                </div>
                <div className={styles.subHeader}>
                    {subHeader}
                </div>
            </div>
        </HeaderCell>)}
    </Row>)
}

export default KmosDateHeaderRow;